import { createContext } from 'react';

export const pages = ['section', 'note', 'editor']
// export pages
export const PageContext = createContext({isPage: false, page: pages[0], setPage: () => {} })